import http from '../api/api'
import config from '../api/constants'

// eslint-disable-next-line import/prefer-default-export
const getFAQ = async () => {
  try {
    const reqParams = {
      requestId: 'FAQ',
      module: "INFO"
    }
    const response = await http.post(config.apiRoute.GET_FAQ, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const FaqService = {
  getFAQ
}
export default FaqService